import "./Imprint.css";

const Imprint = () => {
  return (
    <div className="app__imprint-wrapper">
      {window.scrollTo(0, 0)}
      <h1>Impressum</h1>

      <h2>Angaben gem&auml;&szlig; &sect; 5 TMG</h2>
      <p>
        Bellini
        <br />
        Franzplatz
        <br />
        67487 Maikammer
      </p>

      <p>
        <strong>Vertreten durch:</strong>
        <br />
        Salvatore Vitanza
      </p>

      <h2>Kontakt</h2>
      <p>
        Telefon: +4963216790131
        <br />
        E-Mail: info@cafebellini.de
      </p>

      <p>
        Design & Umsetzung:{" "}
        <a href="https://­www.ionae.de/">Jona Kuhn - ionae.de</a>
      </p>

      <h2>Umsatzsteuer-ID</h2>
      <p>
        Umsatzsteuer-Identifikationsnummer gem&auml;&szlig; &sect; 27 a
        Umsatzsteuergesetz:
        <br />
        DE275935336
      </p>
      <h2>EU-Streitschlichtung</h2>
      <p>
        Die Europ&auml;ische Kommission stellt eine Plattform zur
        Online-Streitbeilegung (OS) bereit:{" "}
        <a
          href="https://ec.europa.eu/consumers/odr/"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://ec.europa.eu/consumers/odr/
        </a>
        .<br /> Unsere E-Mail-Adresse finden Sie oben im Impressum.
      </p>

      <h2>
        Verbraucher&shy;streit&shy;beilegung/Universal&shy;schlichtungs&shy;stelle
      </h2>
      <p>
        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
        vor einer Verbraucherschlichtungsstelle teilzunehmen.
      </p>

      <p>
        Quelle: <a href="https://www.e-recht24.de">e-recht24.de</a>
      </p>
    </div>
  );
};

export default Imprint;
<div>
  <h1>Impressum</h1>

  <h2>Angaben gem&auml;&szlig; &sect; 5 TMG</h2>
  <p>
    Muster GbR
    <br />
    Musterstra&szlig;e 111
    <br />
    Geb&auml;ude 44
    <br />
    90210 Musterstadt
  </p>

  <p>
    <strong>Vertreten durch:</strong>
    <br />
    Dr. Harry Mustermann
    <br />
    Luise Beispiel
  </p>

  <h2>Kontakt</h2>
  <p>
    Telefon: +49 (0) 123 44 55 66
    <br />
    Telefax: +49 (0) 123 44 55 99
    <br />
    E-Mail: mustermann@musterfirma.de
  </p>

  <h2>Umsatzsteuer-ID</h2>
  <p>
    Umsatzsteuer-Identifikationsnummer gem&auml;&szlig; &sect; 27 a
    Umsatzsteuergesetz:
    <br />
    DE999999999
  </p>

  <h2>EU-Streitschlichtung</h2>
  <p>
    Die Europ&auml;ische Kommission stellt eine Plattform zur
    Online-Streitbeilegung (OS) bereit:{" "}
    <a
      href="https://ec.europa.eu/consumers/odr/"
      target="_blank"
      rel="noopener noreferrer"
    >
      https://ec.europa.eu/consumers/odr/
    </a>
    .<br /> Unsere E-Mail-Adresse finden Sie oben im Impressum.
  </p>

  <h2>
    Verbraucher&shy;streit&shy;beilegung/Universal&shy;schlichtungs&shy;stelle
  </h2>
  <p>
    Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor
    einer Verbraucherschlichtungsstelle teilzunehmen.
  </p>

  <p>
    Quelle: <a href="https://www.e-recht24.de">e-recht24.de</a>
  </p>
</div>;
